/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/window.d.ts" />
/// <reference path="../../customtypings/angular-google-maps/angular-google-maps.d.ts" />

/**
 * Geocode service
 */

namespace Application.Services {
    'use strict';

    // import Gateway = Models.Gateway;
    // import IGateway = Models.IGateway;
    // import IHalList = Models.IHalList;
    // import HalConverter = Models.HalConverter;
    // import IHalElement = Models.IHalElement;

    /**
     * GatewayService
     */
    export class GeocodeService {
        public static $name: string = "geocodeService";
        public static $inject: string[] = ['$http'];

        private $http: ng.IHttpService;

        constructor($http: ng.IHttpService) {
            this.$http = $http;
        }
        
        public geocode(address: string): ng.IPromise<google.maps.custom.IGeocodingResponse> {
            return this.$http
                .get('https://maps.googleapis.com/maps/api/geocode/json?address=' + address,
                    { withCredentials: false, data: Application.googleMapsApiKey })
                .then((res: ng.IHttpPromiseCallbackArg<google.maps.custom.IGeocodingResponse>) => {
                    return res.data;
                })
                .catch(() => {
                    return undefined;
                });
        }

        public address(lat: number, lng: number): ng.IPromise<google.maps.custom.IGeocodingResponse> {
            return this.$http
                .get('http://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat + ',' + lng,
                    { withCredentials: false, data: Application.googleMapsApiKey })
                .then((res: ng.IHttpPromiseCallbackArg<google.maps.custom.IGeocodingResponse>) => {
                    return res.data;
                })
                .catch(() => {
                    return undefined;
                });
        }
    }
}